<template>
  <div id="main_layout_v2" :class="$mq" >
    <img id="header_img" src="@/assets/imgs/v3-header.png" />

    <div id="subscribe_container">
      <LandingSubscribe version="v3" />
    </div>

    <div id="footer_container">
      <div id="channels_container">
        <p><b>Follow us on:</b></p>

        <div id="channels">
          <a href="https://instagram.com/devnullprod">
            <img src="@/assets/imgs/IG.svg" />
          </a>

          <a href="https://x.com/devnullprod">
            <img src="@/assets/imgs/X.svg" />
          </a>

          <a href="https://www.youtube.com/@devnullprod">
            <img src="@/assets/imgs/YT.svg" />
          </a>

          <a href="https://twitch.com/devnullprod">
            <img src="@/assets/imgs/Twitch.svg" />
          </a>

          <a href="https://store.steampowered.com/search/?developer=Dev%20Null%20Productions">
            <img src="@/assets/imgs/Steam.svg" />
          </a>

          <a href="https://www.linkedin.com/company/devnullprod">
            <img src="@/assets/imgs/linkedin.svg" />
          </a>

          <a href="https://www.facebook.com/people/Dev-Null-Prod/100063785149118/">
            <img src="@/assets/imgs/FB.svg" />
          </a>

          <a href="https://www.tiktok.com/@devnullprod">
            <img src="@/assets/imgs/TikTok.svg" />
          </a>

          <a href="https://bsky.app/profile/devnullprod.bsky.social">
            <img src="@/assets/imgs/BlueSky.svg" />
          </a>

          <a href="https://www.threads.net/@devnullprod">
            <img src="@/assets/imgs/Threads.svg" />
          </a>
        </div>
      </div>

      <h6>© Copyright 2025, Dev Null Productions<br/>ALL RIGHTS RESERVED</h6>
    </div>
  </div>
</template>

<script>
import LandingSubscribe from '@/components/V2/LandingSubscribe'

export default{
  name : 'LandingV3',

  components: {
    LandingSubscribe
  }
}
</script>

<style scoped lang="scss">
@import '@/scss/custom.scss';

#main_layout_v2{
  background-image: url("~@/assets/imgs/v3-bg.png");
  background-size: 100% 100%;
  color: $white;
  min-height: 100%;
  width: 100%;
  font-family: Bricolage Grotesque;
  display: flex;
  flex-direction: column;
}

#main_layout_v2 #header_img{
  margin: auto;
  padding-top: 125px;
}

#main_layout_v2.xs #header_img{
  width: 60%;
  padding-top: 50px;
}

#main_layout_v2 #subscribe_container{
  width: 60%;
  margin: auto;
  margin-top: 100px;
  margin-bottom: 50px;
}

#main_layout_v2.sm #subscribe_container{
  width: 80%;
}

#main_layout_v2.xs #subscribe_container{
  width: 95%;
  margin-top: 50px;
}

#main_layout_v2 #newsletter_container{
  margin-top: 25px;
  margin-bottom: 5px;
}

#main_layout_v2 #footer_container{
  width: 60%;
  margin: auto;
  flex-grow: 1;
  align-content: flex-end;
}

#main_layout_v2.sm #footer_container{
  width: 80%;
  left: 11%;
}

#main_layout_v2.xs #footer_container{
  width: 95%;
  left: 5%;
}

#channels_container{
  margin-bottom: 15px;
  border-radius: 50px;
  padding: 15px 25px;
  background-image: linear-gradient($grey-5-alpha62, $black-alpha62);
  display: flex;
  align-items: center;
  gap: 25px;
  width: fit-content;
}

#main_layout_v2.md #channels_container{
  margin: auto;
}

#main_layout_v2.sm #channels_container,
#main_layout_v2.xs #channels_container{
  display: block;
  padding: 10px 15px;
  margin: auto;
}

#main_layout_v2.sm #channels_container,
#main_layout_v2.xs #channels_container{
  text-align: center;
}

#channels_container p{
  margin: 0;
  font-size: 0.75rem;
}

#channels{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 15px;
}

#main_layout_v2.sm #channels,
#main_layout_v2.xs #channels{
  margin: auto;
}

#channels img{
  width: 16px;
}

#main_layout_v2 h6{
  margin-top: 25px;
  font-size: 0.75rem;
  padding-left: 5px;
}
</style>
